/**
 * Builds itinerary header / trip form state from a trip aggregate.
 */
import type { TripDetail, TripFormState } from '../../types';
import { toMantineDateTimeString } from '../mantineDateUtils';

export function buildSummaryFormState(
  trip: TripDetail,
  locale: string
): TripFormState {
  return {
    name: trip.name,
    description: trip.description ?? '',
    visibility: trip.visibility,
    status: trip.status,
    occasions: trip.occasions,
    lockEnabled: trip.lockStartDate !== null,
    lockStartDate: trip.lockStartDate
      ? toMantineDateTimeString(trip.lockStartDate, locale)
      : '',
    lockEndDate: trip.lockEndDate
      ? toMantineDateTimeString(trip.lockEndDate, locale)
      : '',
    budgetEnabled: trip.budgetAmount !== null,
    budgetAmount: trip.budgetAmount != null ? String(trip.budgetAmount) : '',
    budgetCurrency: trip.budgetCurrency ?? 'USD',
  };
}
